module.exports = __webpack_public_path__ + "img/14-boy.2711f2b5.svg";